import { NgModule } from '@angular/core';
import { BulkContainersRoutingModule } from './bulk-containers-routing.module';
import { BulkContainersSharedModule } from './bulk-containers-shared.module';

@NgModule({
  imports: [
    BulkContainersSharedModule,
    BulkContainersRoutingModule,
  ],
  exports: [
    BulkContainersSharedModule,
  ],
})
export class BulkContainersModule { }
